import { diagnosticsApi, type DxRoomDto } from "@/api/diagnostics";
import { MasterListPage } from "./MasterListPage";
import { MasterFormPage } from "./MasterFormPage";
import { statusColumn, TextFieldCell, SwitchCell } from "./fields";

const BASE = "/diagnostics/rooms";
const LIST_KEY = ["dx-rooms"];

export function DiagnosticsRoomsPage() {
  return (
    <MasterListPage<DxRoomDto>
      breadcrumbs={["Diagnostics", "Masters"]}
      title="Rooms"
      subtitle="Physical rooms that diagnostic facilities sit in."
      queryKey={LIST_KEY}
      listFn={(inc) => diagnosticsApi.listRooms(inc)}
      deleteFn={diagnosticsApi.deleteRoom}
      basePath={BASE}
      newLabel="New room"
      labelOf={(r) => r.name}
      deleteNote="It will be refused while any facility is still housed in it."
      searchPlaceholder="Search by code, name, or floor"
      columns={[
        { field: "code", headerName: "Code", width: 140 },
        { field: "name", headerName: "Name", flex: 1, minWidth: 220 },
        {
          field: "floor", headerName: "Floor", width: 120,
          valueFormatter: (v: string | null | undefined) => v ?? "—",
        },
        statusColumn<DxRoomDto>(),
      ]}
    />
  );
}

interface Values { code: string; name: string; floor: string; isActive: boolean }

export function RoomFormPage() {
  return (
    <MasterFormPage<Values, DxRoomDto>
      breadcrumbs={["Diagnostics", "Rooms"]}
      noun="room"
      basePath={BASE}
      listQueryKey={LIST_KEY}
      detailQueryKey={(id) => ["dx-room", id]}
      defaultValues={{ code: "", name: "", floor: "", isActive: true }}
      getFn={diagnosticsApi.getRoom}
      toValues={(d) => ({ code: d.code, name: d.name, floor: d.floor ?? "", isActive: d.isActive })}
      createFn={(v) => diagnosticsApi.createRoom({ code: v.code.trim(), name: v.name.trim(), floor: v.floor.trim() || null })}
      updateFn={(id, v) => diagnosticsApi.updateRoom(id, {
        code: v.code.trim(), name: v.name.trim(), floor: v.floor.trim() || null, isActive: v.isActive,
      })}
    >
      {({ control }, isEdit) => (
        <>
          <TextFieldCell control={control} name="code" label="Code" span={4} required />
          <TextFieldCell control={control} name="name" label="Name" span={5} required />
          <TextFieldCell control={control} name="floor" label="Floor" span={3} />
          {isEdit && <SwitchCell control={control} name="isActive" label="Active" />}
        </>
      )}
    </MasterFormPage>
  );
}
